import config from './config';
import { SEOConfigType } from './types'

export default config;

export type {
    SEOConfigType,
}
